var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('span',{staticClass:"lamp",class:_vm.value ? 'blue' : 'red',on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.value ? '알림성공' : '알림실패'))])])}
var staticRenderFns = []

export { render, staticRenderFns }